import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchBodyInsuranceFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyInsurance/patchBodyInsuranceFunction';
import { PatchBodyInsuranceType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyInsurance/patchBodyInsurance.type';

export const patchBodyInsuranceOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchBodyInsuranceType
> => ({
  mutationKey: ['patch-body-insurance-property'],
  mutationFn: ({ id, formData }: PatchBodyInsuranceType) =>
    patchBodyInsuranceFunction({ id, formData }),
});
